export default __webpack_public_path__ + "static/media/MyBestTA.6f2b53ca.svg";